<template>
	<div class="learningReport" id="learningReport">
		<DownloadProgress :totalPages="totalPages" :currentPage="currentPage" v-show="isDownloading"></DownloadProgress>
		<div class="pdf" style="background-color:#E8E8E8;" v-show="isHadReport">
			<PageCover :user="user"  :total="total" :part1Total="part1Total" :part2Total="part2Total" :part3Total="part3Total" ></PageCover>
            <PageList :list="listData"></PageList>
			<PagePart1 v-if="part1Data.constructor === Object" :norm="part1Data.norm" :comment="part1Data.comment" :partIndex="part1Index"></PagePart1>	
			<PagePart2 v-if="part2Data.constructor === Object" :norm="part2Data.norm" :comment="part2Data.comment" :partIndex="part2Index"></PagePart2>	
			<PagePart3 v-if="part3Strategy.constructor === Object && part3style.constructor === Object" :strategyNorm="part3Strategy.norm" :strategyComment="part3Strategy.comment" :styleNorm="part3style.norm" :styleComment="part3style.comment"  :partIndex="part3Index"></PagePart3>	
			<PagePart4 v-if="part4Data.constructor === Object" :norm="part4Data.norm" :comment="part4Data.comment" :partIndex="part4Index"></PagePart4>	
			<PageBgCover></PageBgCover>	
		</div>
		<div class="get_pdf" v-show="isHadReport">
			<div class="inner">
				<div class="btn_pdf" v-on:click="goDownload()">下载报告</div>
			</div>
		</div>
		<div class="no_report" v-show="!isHadReport">
			<p>测评未完成，暂无报告！</p>
		</div>
		<div class="loading" v-show="isLoading">
			<Loading></Loading>
		</div>
	</div>
</template>
<script>
(function(){
　　var w=window.screen.width;
    // console.log(w);//获取屏幕尺寸
    // alert(w)
　　var targetW=900;//之后所有的都是按照320来做
　　var scale = w/targetW;//缩放值:当前尺寸/目标尺寸
　　var meta=document.createElement("meta");
　　meta.name="viewport";
　　meta.content="width=device-width,initial-scale=" + scale + ",minimum-scale=" + scale;
　　document.head.appendChild(meta);
})()
import DownloadProgress from '../../../components/learningAbility/DownloadProgress.vue';
import Loading from '../../../components/learningAbility/Loading2.vue';
import PageCover from './components/PageCover.vue';//封面
import PageList from './components/PageList.vue';//目录
import PagePart1 from './components/PagePart1.vue';//学习潜力
import PagePart2 from './components/PagePart2.vue';//学习动力
import PagePart3 from './components/PagePart3.vue';//学习效力
import PagePart4 from './components/PagePart4.vue';//心理健康
import PageBgCover from './components/PageBgCover.vue';//尾封面
export default {
	components: { DownloadProgress, PageCover, PageList, PageBgCover, PagePart1, PagePart2, PagePart3, PagePart4, Loading },
    props: [],
    data() {
        return {
        	isLoading: true,
    	    isDownloading: false, //是否正在下载
            totalPages: 1, //总页数
            currentPage: 0,//当前页
        	// isDownlondPdf: true

        	// 获取报告时用的参数
        	userName: '',
        	schoolID: '',
          startTime: '',
          endTime: '',
        	htmlTitle: '',
        	reportData: null,
        	isHadReport: false,
        	user: {},
        	part1Data: [],
        	part2Data: [],
        	part3Strategy: [],
        	part3style: [],
        	part4Data: [],
        	total: [],

        	part1Index: 0,
        	part2Index: 0,
        	part3Index: 0,
        	part4Index: 0,
        	listData: [],
        	list: [
        		{ title: '学习潜力', num: '', sTitle: [{s_title: '.1 学习潜力评估结果',num: '', gTitle: []}, {s_title: '.2 学习潜力分析',num: '', gTitle: []}] },
        		{ title: '学习动力', num: '', sTitle: [{s_title: '.1 学习动力评估结果',num: '', gTitle: []}, {s_title: '.2 学习动力分析',num: '', gTitle: []}] },
        		{ title: '学习效力', num: '', sTitle: [
        			{s_title: '.1 学习策略',num: '', gTitle: [{g_title: '.1.1 学习策略评估结果',num: ''},{g_title: '.1.2 学习策略分析',num: ''}]}, 
        			{s_title: '.2 学习风格',num: '', gTitle: [{g_title: '.2.1 学习风格评估结果',num: ''},{g_title: '.2.2 学习风格分析',num: ''}]}
        		] },
        		{ title: '心理健康', num: '', sTitle: [{s_title: '.1 心理健康评估结果',num: '', gTitle: []}, {s_title: '.2 心理健康分析',num: '', gTitle: []}] }
        	]
        }
    },
    computed: {
    	part1Total() {
    		if(this.part1Data.constructor === Object) {
				return this.part1Data.norm[9];
    		}else {
    			return null;
    		}
    	},
    	part2Total() {
    		if(this.part2Data.constructor === Object) {
				return this.part2Data.norm[4];
    		}else {
    			return null;
    		}
    	},
    	part3Total() {
    		if(this.part3Strategy.constructor === Object) {
				return this.part3Strategy.norm[12];
    		}else {
    			return null;
    		}
    	}
    },
    watch: {
        isDownloading() {
            let isDownloading = this.isDownloading;
            if(isDownloading) {
                document.body.style.overflow='hidden';
            }else {
                document.body.style.overflow='visible';

            }
        }
    },
    created() {
    	this.getReportData();
    },
    mounted() {
        $('title').html('学习力测评报告')
    },
    beforeDestroy() {
        document.body.style.overflow='visible';
        $('title').html('学习力测评')
    },
    methods: {
        getPartIndex() {
        	let isHadReport = false;
	        let data1 = this.part1Data;
        	let data2 = this.part2Data;
        	let data3 = this.part3Strategy;
        	let data4 = this.part4Data;
        	let list = this.list;
        	let partIndex = 0;
        	if(data1.constructor === Object) {
        		isHadReport = true;
				partIndex ++;
				this.part1Index = partIndex;
				this.listData.push(list[0]);
        	}
        	if(data2.constructor === Object) {
        		isHadReport = true;
        		partIndex ++;
				this.part2Index = partIndex;
				this.listData.push(list[1]);
				
        	}
        	if(data3.constructor === Object) {
        		isHadReport = true;
        		partIndex ++;
				this.part3Index = partIndex;
				this.listData.push(list[2]);
        	} 
        	if(data4.constructor === Object) {
        		isHadReport = true;
        		partIndex ++;
				this.part4Index = partIndex;
				this.listData.push(list[3])
        	}
        	this.isHadReport = isHadReport;
        },
        // 获取报告
        getReportData() {
            let _this = this;
            let url = '';
            let url1 = '/v1_c/common/report/getByTokenAndDate';// 根据token和时间端获取报告信息
            let url2 = '/v1_c/report/getDataByUserInfo'; //根据 时间段，签名，学生信息（学号和学校），获取报告
            let query = this.$route.query;
            let userName = query.userName;
            let schoolID = query.schoolID;
            let startTime = query.startTime;
            let endTime = query.endTime;
            let obj = {};

            if(schoolID) {
            	obj.userName = userName;
            	obj.schoolID = schoolID;
            	obj.startTime = startTime;
            	obj.endTime = endTime;
            	url = url2;
            }else {
            	obj.startTime = startTime;
            	obj.endTime = endTime;
            	url = url1;
            }
            this.$ajax.post(this.G_lcapi + url, obj,{
                    headers:{
                        token: window.sessionStorage.getItem('ymtxToken')
                    }
                })
                // 监听数据返回
                .then((res)=> {
	                if(res.data.code === 0) {
                        let data = res.data.result.data;
	                	this.isLoading = false;
                        if(data.constructor === Object) {
                            let realname = res.data.result.user.realname;
                            let updated_at = this.getReportDate(res.data.result.user.updated_at);
    	                	this.reportData = data;
    	                	this.user = res.data.result.user;
    	                	this.part1Data = data[1];
    	                	this.part2Data = data[2];
    	                	this.part3Strategy = data[3].strategy;
    	                	this.part3style = data[3].style;
    	                	this.part4Data = data[4];
    	                	this.total = data.total;
                            this.htmlTitle = realname +  '-学习力报告-' + updated_at;
    	                	this.getPartIndex();
                        }
                        this.$nextTick(()=>{
                            this.countPage();
                        })
	                }else if(res.data.code == 1016) {
                        this.url();
                    }
                })
                .catch(function(error) {
                    console.log(error)
                    // alert(error)
                })
        },

        countPage() {
        	let pageNumber = 0;
        	$('.page_main').each(function() {
        		pageNumber++;
        		$(this).find('.big_page_number').html(pageNumber);
        	})

        	$('.page_header').each(function(index) {
        		let number = $(this).parent().find('.big_page_number').html();
        		let big_title_box = $('.page_mulu').find('.big_title_box')[index];
        		$(big_title_box).find('.page_number').html(number);
        	})
        	$('.part_big_title_num').each(function(index) {
        		let number = $(this).parent().find('.big_page_number').html();
        		let small_title_box = $('.page_mulu').find('.small_title_box')[index];
        		$(small_title_box).find('.page_number').html(number);
        	})
       		$('.part_small_title_num').each(function(index) {
        		let number = $(this).parent().find('.big_page_number').html();
        		let small_title_box = $('.page_mulu').find('.g_small_title_box')[index];
        		$(small_title_box).find('.page_number').html(number);
        	})
        },
        goDownload() {
            window.scrollTo(0, 0);
            this.isDownloading = true;
            this.getPdf(this.htmlTitle);
        },
        getReportDate(time) {
            var now=new Date(time);
            var year=now.getFullYear(); 
            var month=now.getMonth()+1; 
            var date=now.getDate();  
            return year+month+date; 
        }
    },
}
</script>
<!-- <style type="text/css" lang='less' scoped>
	@import './components/report.less';
</style> -->
<style type="text/css" lang='less' scoped>
.learningReport {
	width: 100%;
	padding-top: 20px;
	padding-bottom: 20px;
	background-color: #E8E8E8;
	color: #333;
	font-size: 16px;
	.loading {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 999999999;
		background-color: #fff;
	}
	.no_report {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 40px;
        background-color: #e8e8e8;
	}
	.get_pdf {
		height: 0px;
		width: 100%;
		position: fixed;
		top: 30%;
		.inner {
			width: 900px;
			margin: 0 auto;
			position: relative;
			.btn_pdf {
				box-sizing: border-box;
				position: absolute;
				padding: 5px 10px;
				right: -40px;
				width: 40px;
				text-align: center;
				background-color: #2c8ffc;
				color: #fff;
				cursor: pointer;
				border-radius: 5px;
			}
		}
	}
	.pdf {
		width: 900px;
		margin: 0 auto;
		background-color: #fff;
	}
}
</style>
